var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M17.8571 -0.000183105H2.14286C1.57454 -0.000183105 1.02949 0.225582 0.627628 0.627445C0.225765 1.02931 0 1.57435 0 2.14267L0 17.857C0 18.4253 0.225765 18.9703 0.627628 19.3722C1.02949 19.7741 1.57454 19.9998 2.14286 19.9998H8.27009V13.2003H5.45759V9.99982H8.27009V7.56053C8.27009 4.78598 9.92188 3.25339 12.4518 3.25339C13.6634 3.25339 14.9304 3.46946 14.9304 3.46946V6.19267H13.5344C12.1589 6.19267 11.7299 7.04625 11.7299 7.92169V9.99982H14.8004L14.3094 13.2003H11.7299V19.9998H17.8571C18.4255 19.9998 18.9705 19.7741 19.3724 19.3722C19.7742 18.9703 20 18.4253 20 17.857V2.14267C20 1.57435 19.7742 1.02931 19.3724 0.627445C18.9705 0.225582 18.4255 -0.000183105 17.8571 -0.000183105Z",
    fill: "#021C3C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFb);
export default __webpack_public_path__ + "static/media/fb.fd23d968ac45f26bf77c5545c65aad53.svg";
export { ForwardRef as ReactComponent };